export default "__VITE_ASSET__CmElkQH5__"